import Instance from '../../../Axios';

const GetAeroportosTimeline = () => async (dispatch) => {
  await Instance()
    .get(`/intervencoes/intervencoes/aeroportos`)
    .then(({ data }) => {
      dispatch({ type: 'INTERVENCOES_TIMELINE_AEROPORTOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAeroportosTimeline;